import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../../../../../store/hooks';
import usePermission from '../../../../../../permissions-handling/permissionHook';
import { PermissionEnum } from '../../../../../../core/enums/dictionariesEnums';
import Switch from '../../../../../../core/components/switch/Switch';
import Pagination from '../../../../../../core/components/pagination/Pagination';
import Timeline from '../../../../../../core/components/timeline/Timeline';
import {
  partViewPageTimelineFiltersSelector,
  partViewPageTimelineSelector,
} from '../../../../../../store/selectors/stockSelectors';
import { setPartViewPageTimelineFilters } from '../../../../../../store/slices/stockSlice';
import {
  getPartViewTimeline,
  postPartViewTimelineNoteThunk,
} from '../../../../../../store/thunks/stock/part/partViewPageThunks';
import PartViewActivityEvent from './PartViewActivityEvent';
import { getPartViewEventTypesThunk } from '../../../../../../store/thunks/core/coreEventTypesThunks';
import ActivityLabel from '../../../../../../common/components/activity-events/ActivityLabel';
import ActivityNoteInput from '../../../../../../common/components/activity-events/ActivityNoteInput';

const PartViewPageActivityLog: React.FC = () => {
  const [value, setValue] = useState('');

  const { id } = useParams();
  const dispatch = useAppDispatch();
  const timelineFilters = useAppSelector(partViewPageTimelineFiltersSelector);
  const { items, totalCount } = useAppSelector(partViewPageTimelineSelector);
  const allowedToAddNote = usePermission(PermissionEnum.StockPartViewPage);

  const timelineList = items.map((el) => ({
    label: <ActivityLabel time={el.dateTime} initiator={el.initiator} />,
    description: <PartViewActivityEvent item={el} />,
  }));

  useEffect(() => {
    dispatch(getPartViewEventTypesThunk());
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    id && dispatch(getPartViewTimeline({
      partId: +id,
      filters: timelineFilters,
    }));
    // eslint-disable-next-line
  }, [id, timelineFilters.mainOnly, timelineFilters.page]);

  const addNote = () => {
    id && dispatch(postPartViewTimelineNoteThunk({
      partId: +id, content: value.trim(), setValue: () => setValue(''),
    }));
  };
  return (
    <section className="detailsWrap__activity info-grid__column">
      <div className="info-grid__title-wrapper">
        <h2 className="info-grid__title-inner">Activity</h2>
        <Switch
          checked={!timelineFilters.mainOnly}
          onChange={(val) => dispatch(setPartViewPageTimelineFilters({ ...timelineFilters, mainOnly: !val, page: 1 }))}
          textLeft="Main events"
          textRight="Full log"
          singleBackground
        />
      </div>
      <Pagination
        currentPage={timelineFilters.page}
        pageSize={timelineFilters.pageSize}
        onChange={(page) => {
          dispatch(setPartViewPageTimelineFilters({ ...timelineFilters, page }));
        }}
        totalItems={totalCount}
        showSizeChanger={false}
        showTotal={false}
      />
      <Timeline timelineList={timelineList} className="detailsWrap__activity-log" />
      <ActivityNoteInput
        value={value}
        setValue={setValue}
        addNote={addNote}
        disabledInput={!allowedToAddNote}
      />
    </section>
  );
};

export default PartViewPageActivityLog;
